import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 49452 70362"
    {...props}
  >
    <path
      d="M14014 8489v50372h28415c2256 0 3995 548 5204 1643 1224 1111 1819 2497 1819 4155 0 1693-595 3078-1788 4124-1191 1048-2947 1579-5235 1579H8586c-3045 0-5236-676-6573-2030C676 66979 0 64789 0 61776V8489c0-2819 644-4944 1916-6362C3189 709 4865 0 6943 0c2094 0 3801 693 5106 2094 1305 1402 1965 3545 1965 6395z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
